import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { trackViewItemList } from "@/lib/analytics";
import ProductCard from "@/components/ProductCard";
import { Input } from "@/components/ui/input";
import { Search, Loader2 } from "lucide-react";

const CATS = ["All", "Kids", "Couples", "Parents", "Grandparents", "Pets", "Weddings", "Birthdays", "Memorials", "Holidays", "Instant Downloads"];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  const category = params.get("category") || (params.get("instant") === "true" ? "Instant Downloads" : "All");

  useEffect(() => {
    setLoading(true);
    const p = {};
    const cat = params.get("category");
    const instant = params.get("instant");
    if (instant === "true") p.instant = true;
    else if (cat) p.category = cat;
    if (q) p.q = q;
    api.get("/products", { params: p }).then((r) => {
      setProducts(r.data);
      trackViewItemList(instant === "true" ? "Instant Downloads" : (cat || "Shop"), r.data);
    }).finally(() => setLoading(false));
  }, [params, q]);

  const selectCat = (c) => {
    if (c === "All") setParams({});
    else if (c === "Instant Downloads") setParams({ instant: "true" });
    else setParams({ category: c });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <div className="mb-8">
        <h1 className="font-display text-4xl font-extrabold text-slateink">Shop keepsakes</h1>
        <p className="text-slate-600 mt-2">Personalized digital gifts for every person and occasion.</p>
      </div>

      <div className="flex flex-col md:flex-row md:items-center gap-4 mb-8">
        <div className="relative md:max-w-xs w-full">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input data-testid="shop-search" placeholder="Search products…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9 rounded-full bg-white" />
        </div>
        <div className="flex gap-2 overflow-x-auto hide-scrollbar pb-1">
          {CATS.map((c) => (
            <button key={c} data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => selectCat(c)}
              className={`whitespace-nowrap text-sm font-medium px-4 py-2 rounded-full transition-colors ${category === c ? "bg-amber text-white" : "bg-white text-slate-600 border border-slate-200 hover:border-amber"}`}>
              {c}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="py-24 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-amber" /></div>
      ) : products.length === 0 ? (
        <div className="py-24 text-center">
          <p className="text-slate-500">No products found. Try a different category.</p>
          <Link to="/shop" className="text-amber font-semibold mt-2 inline-block">Reset filters</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
